
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 14.25c-3.281 0-5.966-2.662-5.999-5.94l-.743-5.204a.75.75 0 011.021-.802l3.157 1.263L11.357.365A.754.754 0 0112 0c.262 0 .509.14.643.364l1.921 3.202 3.157-1.263a.76.76 0 01.743.108.755.755 0 01.279.695l-.744 5.206C17.966 11.589 15.28 14.25 12 14.25zM7.563 9A4.522 4.522 0 0012 12.75 4.523 4.523 0 0016.438 9H7.563zM16.6 7.5l.475-3.322-2.546 1.018a.753.753 0 01-.922-.31L12 2.208l-1.607 2.678a.752.752 0 01-.643.364.74.74 0 01-.279-.054L6.926 4.179 7.401 7.5H16.6zM21.279 24.001a.747.747 0 01-.713-.52 8.944 8.944 0 00-4.137-5.063l-2.127 1.701c.212.385.323.813.323 1.257A2.627 2.627 0 0112 24a2.628 2.628 0 01-2.625-2.625c0-.444.111-.872.323-1.257l-2.126-1.701a9.094 9.094 0 00-4.137 5.063.747.747 0 01-.945.483.75.75 0 01-.482-.944 10.531 10.531 0 0110.003-7.274c1.64 0 3.289.399 4.768 1.155a10.435 10.435 0 015.214 6.119c.062.19.046.394-.045.572s-.246.311-.437.372a.732.732 0 01-.232.038zM12 20.25c-.62 0-1.125.505-1.125 1.125S11.38 22.5 12 22.5s1.125-.505 1.125-1.125S12.621 20.25 12 20.25zm0-1.5c.432 0 .852.105 1.229.306l1.661-1.328a8.887 8.887 0 00-2.885-.48c-.938 0-1.872.148-2.777.441l-.117.039 1.661 1.328A2.602 2.602 0 0112 18.75z"}})])
          )
        }
      }
    